import React, {useState, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import HeaderDashboard from "./header.dashaboard";


const DashSearchHeader = ({ onResize, search }) => {
    const navigate = useNavigate();
    const [user, setUser] = useState({ name: '', email: '', role: '' });
    

    useEffect(() => {
 
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            try {
                const parsedUser = JSON.parse(storedUser);
                setUser(parsedUser);
            } catch (error) {
                console.error("Error parsing user data:", error);
                localStorage.removeItem('user');
            }
        }
    }, []);
    // const onResize = () =>{ if (this.props.onResize) {
    //            this.props.onResize();
    //         }}

    const handleSubmitNavigation = (search) => {
        console.log("search head", search)
        if (user.role === 'student') {
            navigate(`/dash_user_search/${search}`);
        } else if (user.role === 'tutor') {
            navigate(`/dash_tutor_search/${search}`);
        } else {
            navigate(`/dash_user_search/${search}`);
        }
    }
    return (
        <header>
            <HeaderDashboard prompt={handleSubmitNavigation} onResize={onResize} search={search}/>
        </header>
    )
}

export default DashSearchHeader